import { RightOutlined, DownOutlined } from "@ant-design/icons";
import React, { useEffect, useState } from "react";
import SortingArrow from "../../../../../../Common/SortingArrow";
import { formatDateFunction } from "../../../../../../utils/helper/utils";
import config from "../../../../../../config";
const QcRequestsList = ({ qcRequestData, orderDetails, qcData }) => {
  const [isRightArrow, setIsRightArrow] = useState("");
  // const [isRightArrowSecond, setIsRightArrowSecond] = useState(false);
  // const [sortOrder, setSortOrder] = useState("asc");
  const handleRightArrow = (val) => {
    setIsRightArrow(val);
  };
  // const handleToggle = () => {
  //   setIsRightArrowSecond(!isRightArrowSecond);
  // };
  // const handleSort = (order) => {
  //   setSortOrder(order);
  //   const sortedData = [].sort((a, b) => {
  //     if (order === "asc") {
  //       return a.yourSortField > b.yourSortField ? 1 : -1;
  //     } else {
  //       return a.yourSortField < b.yourSortField ? 1 : -1;
  //     }
  //   });
  // };

  const [tableData, setTableData] = useState([]);

  useEffect(() => {
    let table_data = [];
    for (let item of qcRequestData) {
      let addedBy = "";
      for (let row of item?.statusLogs) {
        // if (row.status === "pending") {
        //   addedBy = row?.addedBy?.name;
        // }
        if (item.addedBy === row.addedBy.id) {
          addedBy = row?.addedBy?.name;
        }
      }

      let productName = "";
      let productImagesNames = [];
      for (let detail of orderDetails) {
        if (detail.id === item.orderDetailId) {
          // eslint-disable-next-line array-callback-return
          if (detail.type === "custom") {
            productName = "Custom Product";
            // productImagesNames.push(detail?.orderItemJson?.customCakeImages[key]?.image);
            let imageNames = [];
            for (let itm of detail?.orderItemJson?.customCakeImages) {
              imageNames.push({ imageUrl: itm?.image });
            }
            productImagesNames = imageNames;
          } else {
            productName = detail?.orderItemJson?.productLocales?.map((itm) => {
              if (itm.languageCode === "en") return itm.name;
            });
            let imageNames = [];
            for (let itm of detail?.orderItemJson.productUoms) {
              for (let row of itm?.productUomImages) imageNames.push({ imageUrl: row.image });
            }
            productImagesNames = imageNames;
          }
        }
      }

      table_data.push({
        requestId: item.requestId,
        status: item.status,
        createdAt: item.createdAt,
        comment: item.comment,
        productName: productName,
        addedBy: addedBy,
        qcName: Object.keys(qcData).length > 0 ? qcData?.firstName + " " + qcData?.lastName : "-",
        images: item.images,
        other_images: item.other_images ? item.other_images : [],
        other_comment: item.other_comment ? item.other_comment : "",
        productImagesNames: productImagesNames,
      });
    }
    setTableData(table_data);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [qcRequestData]);

  // State to track sorted column and order
  const [sortConfig, setSortConfig] = useState({
    key: null, // column to sort by
    direction: null, // ascending or descending
  });

  // Handle sorting when the SortingArrow is clicked
  const handleSort = (key) => {
    let direction = "ascending";

    // If the column is already sorted, toggle the direction
    if (sortConfig.key === key && sortConfig.direction === "ascending") {
      direction = "descending";
    }

    // Set the new sort config
    setSortConfig({ key, direction });
  };

  // Function to sort data locally based on sortConfig
  const sortedData = [...tableData]?.sort((a, b) => {
    if (!sortConfig.key) {
      return 0; // If no sorting is applied, return unsorted data
    }

    const valueA = a[sortConfig.key];
    const valueB = b[sortConfig.key];

    // Handle sorting for different data types (strings, numbers, etc.)
    if (typeof valueA === "string") {
      return sortConfig.direction === "ascending" ? valueA.localeCompare(valueB) : valueB.localeCompare(valueA);
    }

    if (typeof valueA === "number") {
      return sortConfig.direction === "ascending" ? valueA - valueB : valueB - valueA;
    }

    return 0; // If neither string nor number, no sorting applied
  });

  return (
    <>
      <div className="relative overflow-x-auto">
        <table className="w-full  text-left	 text-sm  text-gray-500">
          <thead className=" text-gray-700 capitalize text-xs	 bg-gray-50">
            <tr>
              <th scope="col" className="px-3 py-3 whitespace-nowrap vertical-top">
                Request ID <SortingArrow onSort={() => handleSort("requestId")} />
              </th>
              <th scope="col" className="px-3 py-3 vertical-top">
                Product Name <SortingArrow onSort={() => handleSort("productName")} />
              </th>
              <th scope="col" className="px-3 py-3 vertical-top">
                Date & Time <SortingArrow onSort={() => handleSort("createdAt")} />
              </th>
              <th scope="col" className="px-3 py-3 vertical-top">
                Request Initiator <SortingArrow onSort={() => handleSort("addedBy")} />
              </th>
              <th scope="col" className="px-3 py-3 vertical-top">
                QC Name <SortingArrow onSort={() => handleSort("qcName")} />
              </th>
              <th scope="col" className="px-3 py-3 vertical-top">
                Status <SortingArrow onSort={() => handleSort("status")} />
              </th>
              <th scope="col" className="px-3 py-3 vertical-top"></th>
            </tr>
          </thead>
          <tbody>
            {sortedData?.map((item, index) => (
              <React.Fragment key={index}>
                <tr className="bg-white text-gray-700">
                  <td className="px-3 py-4 vertical-top font-semibold cursor-pointer">#{item?.requestId}</td>
                  <td className="px-3 py-4 vertical-top">{item.productName}</td>
                  <td className="px-3 py-4 vertical-top">{formatDateFunction(item?.createdAt, "dd/mm/yyyy", true, "")}</td>
                  <td className="px-3 py-4 vertical-top">{item?.addedBy}</td>
                  <td className="px-3 py-4 vertical-top">{item?.qcName}</td>
                  <td className="px-3 py-4 vertical-top">
                    {item.status === "in_review" ? (
                      <span className="flex items-center bg-blue-100 text-[#3B82F6] text-center px-[12px] py-[8px] rounded w-full max-w-[85px] h-[32px] justify-center">
                        In Review
                      </span>
                    ) : null}
                    {item.status === "pending" ? (
                      <span className="flex items-center bg-yellow-100 text-yellow-200 text-center px-[12px] py-[8px] rounded w-full max-w-[76px] h-[32px]">
                        Pending
                      </span>
                    ) : null}
                    {item.status === "approve" ? (
                      <span className="bg-green-50 text-green-200 text-center px-[12px] py-[8px] rounded w-full max-w-[76px] h-[32px]">
                        Approved
                      </span>
                    ) : null}
                    {item.status === "reject" ? (
                      <span className="flex items-center bg-red-200 text-red-100 text-center px-[12px] py-[8px] rounded w-full max-w-[76px] h-[32px]">
                        Rejected
                      </span>
                    ) : null}
                  </td>
                  <td className="px-3 py-4 vertical-top">
                    {isRightArrow !== index ? (
                      <RightOutlined
                        onClick={() => {
                          handleRightArrow(index);
                        }}
                      />
                    ) : (
                      <DownOutlined
                        onClick={() => {
                          handleRightArrow("");
                        }}
                      />
                    )}
                  </td>
                </tr>
                {isRightArrow === index && (
                  <tr className="bg-white text-gray-700">
                    <td colSpan={7} className="pl-[10px]">
                      <div className="flex flex-col">
                        <div className="text-[14px] font-semibold mb-[12px]">Our Submission</div>
                        <div className="text-[14px] font-medium	mb-[8px]">Actual product images</div>
                        <div className="flex gap-[20px] mb-[16px] ">
                          {item?.productImagesNames?.map((itm, ind) => {
                            return <img key={ind} src={config.AWS_URL + itm.imageUrl} alt="cake-img" />;
                          })}
                          {/* <img src="images/cake1.png" alt="cake-img" />
                          <img src="images/cake2.png" alt="cake-img" /> */}
                        </div>

                        <div className="text-[14px] font-medium	mb-[8px]">Images of prepared/packed product</div>
                        <div className="flex gap-[20px] mb-[16px] ">
                          {item?.images?.some((itm) => itm.imageUrl) &&
                            item.images.map((itm, ind) =>
                              itm.imageUrl ? <img key={ind} src={config.AWS_URL + itm.imageUrl} alt="cake-img" /> : null
                            )}
                        </div>
                        <div className="text-[14px] font-medium	mb-[8px]">Additional comments</div>
                        <div className="mb-[16px] text-gray-200">{item.comment}</div>

                        {item?.other_images?.length > 0 ? (
                          <>
                            <div className="text-[14px] font-medium	mb-[8px]">Images of QC approved product</div>
                            <div className="flex gap-[20px] mb-[16px] ">
                              {item?.other_images?.some((itm) => itm.imageUrl) &&
                                item.other_images.map((itm, ind) =>
                                  itm.imageUrl ? <img key={ind} src={config.AWS_URL + itm.imageUrl} alt="cake-img" /> : null
                                )}
                            </div>
                          </>
                        ) : null}

                        {item?.other_comment != "" ? (
                          <>
                            <div className="text-[14px] font-medium	mb-[8px]">QC Additional comments</div>
                            <div className="mb-[16px] text-gray-200">{item.other_comment}</div>
                          </>
                        ) : null}
                      </div>
                    </td>
                  </tr>
                )}
              </React.Fragment>
            ))}
          </tbody>
        </table>
      </div>
    </>
  );
};
export default QcRequestsList;
